/*
  Custom horizontal scrollbar (same look in Chrome, Safari, Firefox).

  Usage: add data-custom-scrollbar to a horizontally scrolling element. The
  native scrollbar is hidden (see .has-custom-scrollbar in template-collection.css)
  and a track + thumb is inserted right after the element. The thumb follows the
  scroll position, can be dragged, and clicking the track jumps there. RTL aware.
  The bar is only shown while the element actually overflows.
*/
(function () {
  function initCustomScrollbar(el) {
    if (el.dataset.customScrollbarReady) return;
    el.dataset.customScrollbarReady = 'true';
    el.classList.add('has-custom-scrollbar');

    var track = document.createElement('div');
    track.className = 'custom-scrollbar';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'custom-scrollbar__thumb';
    track.appendChild(thumb);
    el.insertAdjacentElement('afterend', track);

    var isRtl = function () { return getComputedStyle(el).direction === 'rtl'; };
    var maxScroll = function () { return el.scrollWidth - el.clientWidth; };
    var thumbWidth = 0;

    function update() {
      var max = maxScroll();
      var scrollable = max > 1;
      el.classList.toggle('is-scrollable', scrollable);
      track.hidden = !scrollable;
      if (!scrollable) return;

      var trackWidth = track.clientWidth;
      thumbWidth = Math.max(trackWidth * (el.clientWidth / el.scrollWidth), 40);
      // In RTL scrollLeft runs from 0 to -max; in LTR from 0 to max.
      var progress = Math.min(1, Math.abs(el.scrollLeft) / max);
      var offset = (trackWidth - thumbWidth) * progress;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (isRtl() ? -offset : offset) + 'px)';
    }

    // Drag the thumb
    var dragStartX = 0;
    var dragStartScroll = 0;
    thumb.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dragStartX = event.clientX;
      dragStartScroll = el.scrollLeft;
      thumb.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    });
    thumb.addEventListener('pointermove', function (event) {
      if (!thumb.hasPointerCapture(event.pointerId)) return;
      var free = track.clientWidth - thumbWidth;
      if (free <= 0) return;
      // Moving the thumb by its free travel scrolls by the full scroll range
      // (same sign in LTR and RTL: scrollLeft goes negative towards the left in RTL).
      el.scrollLeft = dragStartScroll + (event.clientX - dragStartX) * (maxScroll() / free);
    });
    var endDrag = function (event) {
      if (thumb.hasPointerCapture(event.pointerId)) thumb.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
    };
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    // Click on the track: centre the thumb on the click point
    track.addEventListener('pointerdown', function (event) {
      if (event.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var free = rect.width - thumbWidth;
      if (free <= 0) return;
      var fromStart = isRtl() ? rect.right - event.clientX : event.clientX - rect.left;
      var progress = Math.min(1, Math.max(0, (fromStart - thumbWidth / 2) / free));
      el.scrollTo({ left: (isRtl() ? -1 : 1) * progress * maxScroll(), behavior: 'smooth' });
    });

    el.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(el);
    } else {
      window.addEventListener('resize', update);
    }
    // Buttons can be added/removed by filtering scripts
    if ('MutationObserver' in window) {
      new MutationObserver(update).observe(el, { childList: true });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-custom-scrollbar]').forEach(initCustomScrollbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
